module.exports = __webpack_public_path__ + "static/img/list-dreamWearFull.6587f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-dreamWearFull.png
// module id = qeV2
// module chunks = 1